import { memo, useCallback, useMemo } from "react";
import { Descriptions, Spin, message, Tabs, Collapse } from "antd";
import { EntityCommonInfoModel } from "../../entities/common";
import { DateTimeViewer } from "..";

interface IndexPageHeaderWithCollectProps {
  title: string;
  query: Function;
  collectMutation: Function;
  collector: (collectCallback: (data: any) => Promise<any>) => JSX.Element;
  generalInfoPresentor?: (info: any) => JSX.Element | null;
}

export const IndexPageHeaderWithCollect = memo(
  ({ title, query, collectMutation, collector, generalInfoPresentor }: IndexPageHeaderWithCollectProps) => {
    const { data, isLoading, isFetching } = query();

    const [collectData] = collectMutation();

    const collect = useCallback(
      async (model: any) => {
        try {
          message.loading({
            content: "در حال گردآوری",
            key: "collectData",
            duration: 0,
          });

          let res = await collectData(model).unwrap();

          message.success({
            content: <span onClick={() => message.destroy("collectData")}>گردآوری اطلاعات با موفقیت انجام شد</span>,
            key: "collectData",
            duration: 0,
            onClick: () => {
              message.destroy("collectData");
            },
          });

          return res;
        } catch {
          message.error({
            content: <span onClick={() => message.destroy("collectData")}>گردآوری اطلاعات با خطا مواجه شد</span>,
            key: "collectData",
            duration: 0,
            onClick: () => {
              message.destroy("collectData");
            },
          });

          return null;
        }
      },
      [collectData]
    );

    const info = useMemo<EntityCommonInfoModel>(
      () => ({
        totalRecords: data?.totalRecords ?? 0,
        lastCreateAt: data?.lastCreateAt ?? "",
        lastUpdateAt: data?.lastUpdateAt ?? "",
      }),
      [data]
    );

    return (
      <Collapse>
        <Collapse.Panel key="1" header={<span className="text-lg">{title}</span>}>
          <Spin spinning={isLoading || isFetching}>
            <Tabs defaultActiveKey="1" tabPosition="top">
              <Tabs.TabPane tab="اطلاعات کلی" key="info">
                {generalInfoPresentor ? (
                  generalInfoPresentor(data)
                ) : (
                  <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
                    <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
                      {info.totalRecords}
                    </Descriptions.Item>
                    <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
                      <DateTimeViewer value={info.lastCreateAt} mode="distance" />
                    </Descriptions.Item>
                    <Descriptions.Item label="آخرین ویرایش" labelStyle={{ color: "gray" }}>
                      <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
                    </Descriptions.Item>
                  </Descriptions>
                )}
              </Tabs.TabPane>
              <Tabs.TabPane tab="کالکت" key="collect">
                {collector(collect)}
              </Tabs.TabPane>
            </Tabs>
          </Spin>
        </Collapse.Panel>
      </Collapse>
    );
  }
);
